module.exports = __webpack_public_path__ + "static/man-woman-tablet-square.4f48e952.jpg";